import { isEmpty } from "lodash-es";
import {
  MenuFilterSettingsResponse,
  MenuFilterValue,
} from "../../types/menuFilters";

export default {
  local: {
    toRequest(input: MenuFilterSettingsLocal) {
      const menuFilters: MenuFilterSettingsRequest[] = [];
      for (const [uuid, values] of Object.entries(input ?? {})) {
        menuFilters.push({ menuFilterUuid: uuid, values });
      }
      return { menuFilters };
    },
    isEmpty(input: object) {
      return !input || isEmpty(input);
    },
  },
  response: {
    toLocal(response: MenuFilterSettingsResponse[] | undefined) {
      const ret: MenuFilterSettingsLocal = {};
      for (const menuFilterSetting of response ?? []) {
        if (menuFilterSetting.menuFilter) {
          // This is coming in from a date filter I believe as null
          ret[menuFilterSetting.menuFilter.uuid] = menuFilterSetting.values;
        }
      }
      return ret;
    },
    isEmpty(response: MenuFilterSettingsResponse[] | undefined) {
      return !response || !response.length;
    },
  },
};

export type MenuFilterSettingsLocal = Record<string, MenuFilterValue[]>;

type MenuFilterSettingsRequest = {
  menuFilterUuid: string;
  values: MenuFilterValue[];
};
